const mTheHeaderNav = {
  mTheHeaderNav: {
    academy: 'Academia',
    // assets: 'proyectos',
    billing: 'Gestión',
    // maps: 'Mapas',
    products: 'Productos',
    projects: 'Formaciones',
    subMenu: 'Menú'
  }
}

export default mTheHeaderNav
